import React, { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import { modalsSelector } from "../../selectors";
import { parseNumToFixed } from "../../utils/common";
import { roleId } from "../../constants/app";
import { updateOrderFromTable } from "../../action/orders";
import swal from 'sweetalert';

const ChangeCashModal = () => {
    const ref = useRef();
    const dispatch = useDispatch();

    const data = useSelector(modalsSelector).changeCashModal;
    const user = useSelector(state => state.user.info);

    const onClose = () => dispatch(setActiveModalAction({ field: 'changeCashModal', value: null }));
    
    const [ changeCash, setChangeCash] = useState(null);

    const onChange = (value) => {
        if (!value) return setChangeCash(null);
        const parsedValue = parseNumToFixed(value);
        if (!parsedValue) return setChangeCash(null);
        return setChangeCash(parsedValue);
    }

    const onSave = async (change) => {
        const sended = { payment: 'cash' };
        let newPaymentTitle;
        if (!change || parseNumToFixed(data.totalPrice) === changeCash) {
            newPaymentTitle = 'Наличные, без сдачи';
            sended.changeCash = 'no';
        } else {
            if (data.totalPrice > changeCash) return swal({
                title: "Указанная сумма для сдачи меньше суммы заказа",
                icon: "warning",
                dangerMode: true,
                button: "Назад"
            })
            newPaymentTitle = `Наличные, сдача с ${changeCash}`;
            sended.changeCash = `c${changeCash}`;
        }

        let checkChangeLog = {};
        let log = data.changeLog;
        const date = new Date();

        if(log) {
            if(typeof log === 'string') {
                checkChangeLog = JSON.parse(log);
            } else {
                checkChangeLog = log;
            }
        }


        let changeLog = {point: `Способ оплаты изменен с ${data.oldPaymentTitle} на ${newPaymentTitle}`}
        const logName = String(user.username + '_' + moment(date).format('DD.MM.YYYY') + '_' + (checkChangeLog ? Object.keys(checkChangeLog).length : 0));

        const username = user.name ? user.name : user.username;
        const roleDescription = user.role && user.role.description ? user.role.description : ''
        const userText = `${username} ${roleDescription}`;

        checkChangeLog[logName] = {
            user: userText,
            date: moment(date).format('DD.MM.YYYY HH:mm:ss'),
            ...changeLog
        }

        sended.changeLog = checkChangeLog;
        await dispatch(updateOrderFromTable(data.id, sended, data.isArchive, [roleId.admin, roleId.manager, roleId.cashier, roleId.regionalDirector, roleId.operationDirector].includes(user.role.id)));
        onClose();
    }

    const renderChange = () => {
        if (data.totalPrice > changeCash) return 'Указанная сумма для сдачи меньше суммы заказа';
        return changeCash - parseNumToFixed(data.totalPrice) + ' руб.';
    }

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-md modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={ window.innerWidth > 1024 ? {} : { maxHeight: 'calc(100vh - 200px)' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> Расчет сдачи </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <span style={{ flex: 1, color: '#000' }}>Итого</span>
                                <span style={{ flex: 1, color: '#000' }}>{data.totalPrice || 0} руб.</span>
                            </div>
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <span style={{ flex: 1, color: '#000' }}>Внесено</span>
                                <input value={changeCash} type="number" style={{ flex: 1, color: '#000', border: '1px solid #e2e5ec', borderRadius: '4px' }} onChange={((e) => onChange(e.target.value))}/>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                <button onClick={() => onChange(1000)} type="button" className="btn btn-lg btn-secondary"> 1000 </button>
                                <button onClick={() => onChange(1500)} type="button" className="btn btn-lg btn-secondary"> 1500 </button>
                                <button onClick={() => onChange(2000)} type="button" className="btn btn-lg btn-secondary"> 2000 </button>
                                <button onClick={() => onChange(5000)} type="button" className="btn btn-lg btn-secondary"> 5000 </button>
                            </div>
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <span style={{ flex: 1, color: '#000' }}>Сдача</span>
                                <span style={{ flex: 1, color: '#000' }}>{renderChange()}</span>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type="button" className="btn btn-success" onClick={() => onSave(true)}>Со сдачей</button>
                        <button type="button" className="btn btn-success" onClick={() => onSave(false)}>Без сдачи</button>
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(ChangeCashModal);